//  Dependencies

import React, { Component} from 'react';

// Components

import Divider from '../Divider/Divider';
import Header from '../Header/Header';
import Testimonial from '../Testimonial/Testimonial';


// Images

import calendar from '../images/calendar.svg';

// Style

import './Testimonials.css';

export default class Testimonials extends Component {
  constructor(props) {
    super(props);

    this.state = { activeTestimonial: 0 };
  }

  render() {
    return (
      <div className="testimonials">
        <div className="testimonials__header-container">
          <div className="testimonials__bg" />
          <div className="testimonials__header">
            <img alt="testimonials" className="testimonials__icon" src={this.props.icon} />
            <h1>{this.props.heading}</h1>
            <p>{this.props.body}</p>
            {this.props.content}
          </div>
        </div>
     </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Testimonials/Testimonials.js